// 弹窗专用
export default {
  props: {

  },
  data() {
    return {
     
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    // 复制
    onCopy(text){
      this.$copyText(text).then(res=>{
        this.$message({
            type: 'success',
            message: `复制成功`
          })
      })
    },
    // 查看详情
    onDetail(item,e){
      console.log('onDetail:',item)
      // orderOrigin=10 矩阵 跳其他页面
      if (item.orderOrigin === 10) {
        const postData = {
          orderSource: 10,
          orderNo: item.orderNo
        }
        let id
        this.$api.omsGetOrderId(postData).then(res=>{ 
          if (res.code ===0 && res.data) {
            id = res.data.orderId
            // 平台物流订单详情
            let name = 'platformIogisticsOrderDetail'
            let query = { id }
            this.$router.push({ name, query })
          }
        })
      }else{
        let name = 'orderDetails'
        let query = { id: item.id, orderId: item.orderId, orderNo: item.orderNo, type:name }
        this.$router.push({ name, query })
      }
      
      e.stopPropagation() 
    },
    // 售后详情
    onAfterSale(item,e){
      let name = 'afterSaleRecordList'
      let query = {  orderNo: item.orderNo}
      this.$router.push({ name, query })
      e.stopPropagation() 
    },
    // 导入
    onImport(){
      this.$refs.popImport.show()
    },
    // 导出
    onExport(type){ 
      let params
      if (type === 'all') {
        
        params = {
          ...this.$parent.$refs.orderSide.form
        }
      }else{
        const orderIds = this.multipleSelection.map(e=>(e.id))
        params = {orderIds}
      }
      this.btnExportLoading = true
      this.$api.omsOrderExport(params).then((res) => {
        if (res.code == 0 && res.data ) {
          if (res.data.downloadUrl) {
            this.downloadlink(res.data.downloadUrl)
            this.btnExportLoading = false
          }else if (res.data.taskId) { 
            this.getCurrentExport()
          } 
        }
      }).catch(() => {
        this.btnExportLoading = false
      })
    },
    // 设置标签
    onSetTag(data){
      let row = {}
      let setData = {
        radio:'',
        check:[],
        
      }
      if (typeof data === 'object') {
        row = data
        this.currentId = data.id
        this.actionType = 'click'
        setData.type = data.type || 'click'
        if (data.type) {
          setData.type = data.type
          setData.check = data.check
          setData.radio = data.radio
        }
      }else{
        this.currentId = ''
        this.actionType = 'select'
        if (this.multipleSelection.length == 1) {
          row = this.list.find(e=>e.id==(this.multipleSelection[0].id))
        }
        setData.type = 'select'
      }
      console.log('>>',row)
      if (row && row.tags && row.tags.length > 0) {
        row.tags.forEach(e => {
            if (e.isFlagTag) {
              setData.radio = e.tagId
            }else{
              setData.check.push(e.tagId)
            }
        })
      }
      console.log('onSetTag>>',data,setData)
      this.$refs.popSetTag.show(setData)
    },
    hasSetTag(data){
      if(data.type =='includeTag' || data.type =='excludeTag'){
        this.$bus.$emit('hasSelectTag',data);
        return false
      }
      if (this.actionType =='click' && this.currentId) {
        data.orderIds = [this.currentId]
      }else if (this.actionType =='select' && this.multipleSelection.length > 0) {
        data.orderIds = this.multipleSelection.map(e=>(e.id))
      }
      // 过滤掉空的tagIds
      if (data.tagIds && Array.isArray(data.tagIds)) {
        data.tagIds = data.tagIds.filter(id => id !== null && id !== undefined && id !== '');
      }
      console.log('hasSetTag:',data)
      // return false
      this.loading = true; 
      this.$api.omsTagSet(data).then(res => {
        if (res.code == 0) {
          let batchNo = res.data.batchNo
            let resultData = {
              title:'设置标签处理结果',
              type:'tag',
              batchNo
            }
          this.$refs.popResultTable.show(resultData)
          this.loading = false
          // 有成功才刷新
          if(res.data && res.data.successCount) {
            this.fetchData()
          }         }
      })
    },
    // 编辑地址
    onEditAddress(item){
      console.log('>>',item)
    },
    // 设置客服备注
    onSetRemark(item){
      this.$refs.popSetRemark.show(item,'remark')
    },
    hasSetRemark(data){
      console.log('hasSetRemark:',data) 
    },
    // 设置售后备注
    onSetSalesRemark(item){
      this.$refs.popSetRemark.show(item,'afterSale')
    },
    // 设置快递
    onSetExpress(data){
      let row = {}
      let setData = {
        radio:'',
        expressList:[]
      }
      if (data) {
        row = data
        this.currentId = data.id
        this.actionType = 'click'
      }else{
        this.currentId = ''
        this.actionType = 'select'
        if (this.multipleSelection.length == 1) {
          row = this.list.find(e=>e.id==(this.multipleSelection[0].id))
        }
      }
      setData.radio = row.specifiedLogisticsId
      setData.expressList = this.$parent.$refs.orderSide.dictionaries.oms_logistics_company
      this.$refs.popSetExpress.show(setData)
    },
    hasSetExpress(data){ 
      if (this.actionType =='click' && this.currentId) {
        data.orderIds = [this.currentId]
      }else if (this.actionType =='select' && this.multipleSelection.length > 0) {
        data.orderIds = this.multipleSelection.map(e=>(e.id))
      }
      console.log('hasSetExpress:',data)
      this.$api.omsLogisticsSet(data).then(res => {
        if (res.code == 0) {
          if (data.orderIds.length==1) {
            if (res.data.successCount) {
              this.$message.success('操作成功')
            }else{
              let message = res.data.orderResults && res.data.orderResults[0] && res.data.orderResults[0].failureReason||'操作失败'
              this.$message.error(message)
            }
            this.loading = false
          }else{
            let batchNo = res.data.batchNo
            let resultData = {
              title:'指定快递处理结果',
              type:'setLogistics',
              batchNo
            }
            this.loading = false
            this.$refs.popResultTable.show(resultData) 
          }
          // 有成功才刷新
          if(res.data && res.data.successCount>0){
            this.fetchData()
          }
        }
      })
    },
    // 指定发货日期
    onSetDate(data){ 
       let row = {}
      let setData = {
        time:'',
      }
      if (data) {
        row = data
        this.currentId = data.id
        this.actionType = 'click'
      }else{
        this.currentId = ''
        this.actionType = 'select'
        if (this.multipleSelection.length == 1) {
          row = this.list.find(e=>e.id==(this.multipleSelection[0].id))
        }
      }
      setData.time = row.appointTime
      // console.log('>>',setData)
     this.$refs.popSetDate.show(setData)
    },
    hasSetDate(data){ 
      if (this.actionType =='click' && this.currentId) {
        data.orderIds = [this.currentId]
      }else if (this.actionType =='select' && this.multipleSelection.length > 0) {
        data.orderIds = this.multipleSelection.map(e=>(e.id))
      }
      console.log('hasSetExpress:',data)
      this.loading = true
      this.$api.omsSetAppointTime(data).then(res => {
        if (res.code == 0) {
          if (data.orderIds.length==1) {
            if (res.data && res.data.successCount) {
              this.$message.success('操作成功')
            }else{

              // let message = res.data.results && res.data.results[0] && res.data.results[0].message||'操作失败'
              let message = res.data&& res.data.results && res.data.results[0] && res.data.results[0].failureReason||'操作失败'
              this.$message.error(message)
            }
            this.loading = false
          }else{
            let batchNo = res.data && res.data.batchNo
            let resultData = {
              title:'指定发货日期结果',
              type:'setOrderDate',
              batchNo
            }
            this.loading = false
            this.$refs.popResultTable.show(resultData) 
          }
          // 有成功才刷新
          if(res.data && res.data.successCount>0){
            this.fetchData()
          }
        }
      })
    },
    // 导出按钮
    commandExport(type){
      if (type === 'ExportPart') { 
        this.onExport()
      } else if (type === 'ExportAll')  { 
        this.onExport('all')
      } 
    },
    // 私域公域审核
    commandAudit(type){
      const orderNos = this.multipleSelection.map(e=>(e.orderNo))
      if (type === 'privateAudit') { 
        this.$refs.popPrivateAudit.show(orderNos) // 私域审核
      } else { 
        this.$refs.popPublicAudit.show(orderNos) // 公域审核
      } 
    },
    // 订单操作记录
    onOrderRecord(item){ 
      this.$refs.popOrderRecord.show(item)
    },
    // 显示商品信息
    onGoodsInfo(item){ 
      this.$refs.popGoodsInfo.show(item)
    },
     // 显示售后信息
    onGoodsAfter(item){ 
      this.$refs.popGoodsAfter.show(item)
    },
    // 修改下单金额
    onGoodsAmount(item){ 
      this.$refs.popGoodsAmount.show(item)
    },
    // 客服订单审核记录
    onAuditRecord(item){ 
      this.$refs.popAuditRecord.show(item)
    },
    // 提成审核 申诉记录
    onAppealRecord(item){
      this.$refs.popAppealRecord.show(item)
    },
    // 物流单号
    onLogistics(item,e) { 
      this.$refs.popLogistics.show(item)
       e.stopPropagation() 
    },
    // 监听右键菜单
    hasClickMenu(data) { 
      let type = data.type
      let item = data.item
      let checkData = {}
      console.log('hasClickMenu：',data)
      switch (type) {
        case 'onDetail': // 查看详情
          this.onDetail(item)
          break;
        case 'onSetTag': // 设置标签
          this.onSetTag(item)
          break;
        case 'onSetRemark': // 设置客服备注
          this.onSetRemark(item)
          break;
        case 'onSetExpress': // 设置快递
          this.onSetExpress(item)
          break;
        case 'onSetDate': // 指定发货日期
          this.onSetDate(item)
          break;
        case 'onOrderRecord': // 订单操作记录
          checkData = {
            id:item.id,
          }
          this.onOrderRecord(checkData)
          break;
        case 'onGoodsInfoEdit': // 修复商品编码缺失
          checkData = {
            orderNo:item.orderNo,
            orderId:item.id,
            type:'edit',
          }
          this.onGoodsInfo(checkData)
          break;
        case 'onGoodsAmount': // 修改商品下单金额
          checkData = {
            orderNo:item.orderNo,
          }
          this.onGoodsAmount(checkData)
          break;
        case 'onSubmitOrder': // 提交订单
          this.onSubmitOrder(item)
          break;
        case 'onResubmit': // 重新提交
          this.onResubmit(item)
          break;
        case 'onRevokeApply': // 撤销申诉
          this.onRevokeApply(item)
          break;
        case 'onConfirmModify': // 确认修改提成
          this.onConfirmModify(item)
          break;
        case 'onConfirmReceipt': // 确认收货
          checkData = {
            orderNo:item.orderNo,
          }
          this.onConfirmReceipt(checkData)
          break;
        case 'onCancelOrder': // 取消订单
          this.onCancelOrder(item)
          break;
        case 'onSubmitApply': // 发起提成申诉
          item.type = 'submitApply'
          this.onSubmitApply(item)
          break;
        case 'onSubmitApplyEdit': // 发起修改提成
          item.type = 'editApply'
          this.onSubmitApply(item)
          break;
        case 'onCheckApply': // 查看提成申诉
          this.onCheckApply(item)
          break;
        default:
          break;
      }
    },
    // 发起提成申诉 & 发起修改提成
    onSubmitApply(data){
      this.$refs.popSubmitApply.show(data)
    },
    // 查看提成申诉
    onCheckApply(data){
      this.$refs.popCheckApply.show(data)
    },
    // 同步订单
    onSyncOrder(item,e) {
       console.log('onSyncOrder:',item)
      e.stopPropagation()
      this.$confirm('是否重新同步订单?', '同步订单', {
          customClass: 'pop-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          // 确认同步订单
        })
    },
    // 提交订单
    onSubmitOrder(item) { 
      this.$confirm('是否确认提交订单？', '提交订单', {
          customClass: 'pop-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          // 确认提交订单
          let postData = { orderNo: item.orderNo }
          this.$api.omsResubmit(postData).then((res) => { 
            if (res.code === 0) {
              this.$parent.fetchData('search')
            }
          })
        })
    },
    // 重新提交
    onResubmit(item) {
      this.$confirm('是否确认重新提交审核？', '重新提交', {
          customClass: 'pop-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          // 确认重新提交
          let postData = { orderNo: item.orderNo }
          this.$api.omsResubmit(postData).then((res) => { 
            if (res.code === 0) {
              this.$parent.fetchData('search')
            }
          })
        })
    },
     // 撤销申诉
    onRevokeApply(item) {
      this.$confirm('是否确认撤销申诉？', '撤销申诉', {
          customClass: 'pop-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          // 确认撤销申诉
          let orderNo = item.orderNo
          this.$api.omsCancelApply(orderNo).then((res) => { 
            if (res.code === 0) {
              this.$message.success('已撤销申诉')
              this.$parent.fetchData('search')
            }
          })
        })
    },
    // 确认修改提成
    onConfirmModify(item) { 
      this.$confirm('是否确认确认修改提成？', '确认修改提成', {
          customClass: 'pop-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          // 确认修改提成
          const postData = { 
            orderNo: item.orderNo,
            auditStatus:item.auditStatus
          }  
          this.$api.omsAuditApply(postData).then((res) => { 
            if (res.code === 0) {
              this.$message.success('已确认修改提成')
              this.$parent.fetchData('search')
            }
          })
        })
    },
    // 确认收货
    onConfirmReceipt(item) { 
      this.$confirm('是否确认改私域订单已收货?', '确认私域订单已收货', {
          customClass: 'pop-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          // 确认收货
          const params = { orderNo: item.orderNo }
          this.$api.omsConfirmReceipt(params).then((res) => { 
             if (res.code === 0) {
              this.$message.success('已确认收货')
              this.$parent.fetchData('search')
            }
          })
        })
    },
    // 取消订单
    onCancelOrder(item) { 
      this.$confirm('是否确认取消/关闭订单?', '取消/关闭订单', {
          customClass: 'pop-message-box',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          // 取消订单
          const params = { orderNo: item.orderNo }
          this.$api.omsCancelOrder(params).then(res => {
             if (res.code === 0) {
              // this.$message.success('已取消订单')
              this.$parent.fetchData('search')
              // 公域订单提示 isPublicDomain 是否公域订单
                if (item.isPublicDomain) {
                  this.$confirm(`订单【${item.orderNo}】取消成功，但线上自动取消失败，请注意手工处理。`, '提示！', {
                    customClass: 'pop-message-box',
                    confirmButtonText: '关闭',
                    showCancelButton:false
                  })
                }
            }
          })
          

        })
    },
  }
}
